export var filter = function (args, condition) {
    return Array.prototype.filter.call(args, condition);
};
export var map = function (args, mapper) {
    return Array.prototype.map.call(args, mapper);
};
